module.exports = __webpack_public_path__ + "static/media/phone-laptop.0346e3c8.svg";